import ChronofieldLogo from "./chronofield_logo_1.webp";
import styled from "styled-components";
import { NavLink as RouterNavLink, Link as RouterLink } from "react-router-dom";

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  box-shadow: var(--shadow-nav);
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 0 var(--space-8);

  @media (max-width: 600px) {
    padding: 0 var(--space-4);
  }
`;

export const HeaderLogoLink = styled(RouterLink)`
  display: flex;
  align-items: center;
  gap: var(--space-3);
  text-decoration: none;
  color: var(--text);
  flex-shrink: 0;
`;

export const HeaderChronofieldLogo = styled.img.attrs({
  src: `${ChronofieldLogo}`,
  alt: "Chronofield Logo",
})`
  width: 34px;
  height: 34px;
  object-fit: contain;
  display: block;
`;

export const HeaderChronofieldLogoName = styled.span`
  font-family: var(--font-display);
  font-size: var(--text-lg);
  font-weight: 600;
  letter-spacing: 0.06em;
  color: var(--text);
  line-height: 1;

  span {
    color: var(--accent);
  }
`;

export const HeaderNavbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  @media (max-width: 600px) {
    display: none;
  }
`;

export const NavLink = styled(RouterNavLink)`
  color: var(--text-muted);
  text-decoration: none;
  padding: 0 var(--space-2);
  border-radius: var(--radius-md);
  &:hover {
    color: var(--text);
  }

  &.active {
    color: var(--accent);
    background: var(--accent-bg);
    font-weight: 500;
  }
`;

export const BurgerMenu = styled.div`
  display: none;
  @media (max-width: 600px) {
    display: block;
    font-size: 2rem;
    margin-right: 0;
    cursor: pointer;
    color: var(--text-muted);
  }
`;

export const DrawerOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index: 1001;
`;

export const Drawer = styled.div`
  position: fixed;
  top: 0; right: 0;
  width: 220px;
  height: 100vh;
  background: var(--surface);
  border-left: 1px solid var(--border);
  z-index: 1002;
  box-shadow: -2px 0 8px rgba(0,0,0,0.1);
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
`;

export const DrawerItem = styled.div`
  margin-bottom: 12px;
  font-size: 1.1rem;
  color: var(--text);
`;

export const DrawerSubMenu = styled.div`
  margin-left: 12px;
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  > a {
    margin-bottom: 4px;
  }
`;

export const ThemeToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  color: var(--text-muted);
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  transition: color var(--transition), background var(--transition), border-color var(--transition);

  &:hover {
    color: var(--accent);
    background: var(--accent-bg);
    border-color: var(--accent);
  }
`;
